"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacyPolicyPage = void 0;
const doshx_controls_web_1 = require("doshx_controls_web");
const react_1 = __importStar(require("react"));
const react_markdown_1 = __importDefault(require("react-markdown"));
const react_redux_1 = require("react-redux");
const PrivacyPolicyPage = (props) => {
    const {} = props;
    const dispatch = (0, react_redux_1.useDispatch)();
    const [privacyData, setPrivacyData] = (0, react_1.useState)("PP needs to be implemented!");
    (0, react_1.useEffect)(() => {
        // user_privacy().then((response) => {
        //   if (response) {
        //     setPrivacyData(response);
        //   } else {
        //     dispatch(
        //       setMainModal({
        //         title: "Oops!", //
        //         messages: ["Sorry! We could not retrieve the privacy policy at the moment! Please try again later."],
        //       })
        //     );
        //   }
        // });
    }, []);
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null,
            react_1.default.createElement(react_markdown_1.default, { className: "flex flex-col gap-4" }, privacyData))));
};
exports.PrivacyPolicyPage = PrivacyPolicyPage;
